import React, { useRef, useState } from 'react';

interface CustomerNameModalProps {
  orderTypeLabel: string;
  onConfirm: (customerName: string) => void;
  onCancel: () => void;
}

const CustomerNameModal: React.FC<CustomerNameModalProps> = ({
  orderTypeLabel,
  onConfirm,
  onCancel,
}) => {
  const [customerName, setCustomerName] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Read from DOM so soft keyboard "Done" doesn't lose the value (state can be one keystroke behind)
    const value = inputRef.current?.value?.trim() ?? customerName.trim();
    onConfirm(value || 'Customer');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 z-[60] flex justify-center items-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
        <div className="bg-gradient-to-r from-pink-500 to-pink-600 text-white px-6 py-3">
          <h2 className="text-xl font-bold">{orderTypeLabel} Order</h2>
          <p className="text-pink-100 text-sm">Enter customer name for this order. It will be shown on the order in Pending and Completed.</p>
        </div>
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Customer name</label>
            <input
              ref={inputRef}
              type="text"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
              placeholder="e.g. John or Order #1234"
              data-testid="customer-name-input"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-pink-500"
              autoFocus
            />
          </div>
          <div className="flex gap-3 pt-2">
            <button
              type="button"
              onClick={onCancel}
              data-testid="customer-name-cancel"
              className="flex-1 py-2 px-4 border border-gray-300 rounded-lg font-medium text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              data-testid="customer-name-continue"
              className="flex-1 py-2 px-4 bg-pink-500 text-white rounded-lg font-medium hover:bg-pink-600"
            >
              Continue to menu
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CustomerNameModal;
